export var role;
(function (role) {
    role["system"] = "system";
    role["user"] = "user";
    role["human"] = "human";
    role["assistant"] = "assistant";
    role["ai"] = "ai";
    role["tool"] = "tool";
    role["shortTermMemory"] = "short-term-memory";
    role["variable"] = "variable";
})(role || (role = {}));
export const OPENAI_TO_LANGCHAIN_ROLE_MAP = {
    [role.user]: role.human,
    [role.assistant]: role.ai
};
export const selectableRoles = [role.system, role.human, role.ai, role.variable];
export function isMemoryTypePrompt(prompt) {
    return prompt.type === role.variable || prompt.type === role.shortTermMemory;
}
export const PRIMITIVE_TYPES = ['string', 'number', 'boolean'];
export const ARRAY_TYPES = [...PRIMITIVE_TYPES, 'object'];
export const ALL_TYPES = [...PRIMITIVE_TYPES, 'array', 'object'];
